module.exports = __webpack_public_path__ + "static/img/qr-code-3.5535f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr-code-3.png
// module id = YY0/
// module chunks = 0